<template>
<div class="modal-container fixed z-10 top-0 left-0">
  <div class="modal-mask fixed w-full h-full bg-black bg-opacity-50 backdrop-blur-lg" v-if="status !== 'button'"></div>
  <div class="fixed pointer-events-auto modal" :class="[status]">
    <div v-if="status === 'button'" class="button-mask" @click="handleTap"></div>
    <img class="icon mr-2" src="@/assets/home/icon-cooperate.svg">
    <h2 class="title flex justify-between items-center">
      <span>合作交流</span>
    </h2>
    <template v-if="showForm">
      <img style="width: 20px;height: 20px;" class="icon-close cursor-pointer"
           src="@/assets/home/icon-close.svg" @click.stop="close">
      <form>
        <input type="text" v-model="formData.name" placeholder="姓名" autocomplete="none" :disabled="formLoading">
        <div class="error-tip">{{ formError.name }}</div>
        <input type="text" v-model="formData.enterprise" placeholder="公司（非必填）" autocomplete="none" :disabled="formLoading">
        <div class="error-tip">{{ formError.enterprise }}</div>
        <input type="text" v-model="formData.phone" placeholder="电话" autocomplete="none" :disabled="formLoading">
        <div class="error-tip">{{ formError.phone }}</div>
        <textarea v-model="formData.cooperationIntention" placeholder="合作意向" autocomplete="none" :disabled="formLoading"></textarea>
        <div class="error-tip">{{ formError.cooperationIntention }}</div>
        <button @click.stop="send" :disabled="formLoading" class="flex items-center justify-center">
          <img v-if="formLoading" class="icon-loading" src="@/assets/home/icon-loading.svg">
          <span v-else>提交</span>
        </button>
      </form>
    </template>
    <template v-if="showResult">
      <div class="flex flex-col items-center justify-between h-full">
        <img src="@/assets/home/submit-success.png" alt="">
        <h3 class="result-title">提交成功</h3>
        <p class="text-center text-sm leading-8" style="color: #898893;">我们已收到您的合作意向，<br>业务人员会尽快与您电话联系！</p>
        <button @click.stop="close">知道了</button>
      </div>
    </template>
  </div>
</div>
</template>

<script>
import axios from "axios";
import {isEmpty} from "lodash";

export default {
  name: 'FormModal',
  data() {
    return {
      visible: false,
      status: 'button',
      showForm: false,
      showResult: false,
      formLoading: false,
      formData: {
        // 姓名
        name: '',
        // 电话
        phone: '',
        // 公司（非必填）
        enterprise: '',
        // 合作意向
        cooperationIntention: ''
      },
      formError: {
        name: '',
        phone: '',
        enterprise: '',
        cooperationIntention: '',
        tenantId: '255590',
      }
    }
  },
  watch: {
    status(v) {
      if(v === 'button') {
        document.body.classList.remove('disable-scroll');
      } else {
        document.body.classList.add('disable-scroll');
      }
    }
  },
  methods: {
    handleTap() {
      this.status = 'form'
      setTimeout(() => {
        this.showForm = true;
      }, 350)
    },
    async send() {
      this.formLoading = true;
      const {name, phone, cooperationIntention} = this.formData;
      let flag = true
      if (isEmpty(name)) {
        this.formError.name = '请填写姓名';
        flag = false
      }
      if (isEmpty(phone)) {
        this.formError.phone = '请填写电话';
        flag = false
      }
      if (!/^(?:(?:\+|00)86)?1[3-9]\d{9}$/.test(phone)) {
        this.formError.phone = '请填写正确的号码';
        flag = false
      }
      // if (isEmpty(cooperationIntention)) {
      //   this.formError.cooperationIntention = '请填写合作意向';
      //   flag = false
      // }
      if(flag) {
        const result = await axios.post('http://api.cms.ygcydn.com:11080/api/cooperate/save', this.formData);
        if(result.data.success) {
          this.status = 'result';
          this.showForm = false;
          this.showResult = true;
        }
      }
      this.formLoading = false;
    },
    open() {
      this.visible = true;
    },
    close() {
      Object.assign(this.$data.formData, this.$options.data().formData);
      Object.assign(this.$data.formError, this.$options.data().formError);
      this.status = 'button';
      this.showForm = false;
      this.showResult = false;
    }
  }
}
</script>

<style lang="scss" scoped>
.modal-mask{
  backdrop-filter: blur(4px);
}
.modal {
  box-shadow: 7px 11px 43px rgba(0, 0, 0, 0.1);
  transition: .35s ease;
  box-sizing: border-box;
  .title{
    transition: .35s ease;
  }
  .button-mask{
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }
  &.button{
    width: 100%;
    height: 56px;
    background: #E84E4E;
    bottom: 0;
    border-radius: 4px 0px 0px 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0;
    cursor: pointer;
    .icon{
      width: 32px;
      height: 32px;
    }
    .title{
      font-weight: 700;
      font-size: 16px;
      color: white;
    }
  }
  &.form{
    background: #FFFFFF;
    bottom: 0;
    width: 100vw;
    height: 634px;
    padding: 52px 32px;
    .icon-close{
      position: absolute;
      top: 20px;
      right: 20px;
    }
    .icon{
      display: none;
    }
    .title{
      font-size: 24px;
      color: #2B2A3D;
      font-weight: 700;
      margin-bottom: 24px;
    }
    form {
      input {
        width: 100%;
        height: 48px;
        border: 1px solid #E0E0E0;
        border-radius: 4px;
        padding: 10px;
        box-sizing: border-box;
        outline: none;
        &:focus{
          border: 1px solid #E84E4E;
        }
      }
      textarea{
        width: 100%;
        height: 140px;
        overflow-y: auto;
        border: 1px solid #E0E0E0;
        border-radius: 4px;
        resize: none;
        padding: 10px;
        box-sizing: border-box;
        outline: none;
        &:focus{
          border: 1px solid #E84E4E;
        }
      }
      .error-tip{
        height: 24px;
        color: #E84E4E;
        font-size: 12px;
        line-height: 24px;
      }
    }
    button{
      background: #E84E4E;
    }
  }
  &.result{
    background: #FFFFFF;
    bottom: 0;
    width: 100vw;
    height: 440px;
    padding: 52px 32px;
    .icon,
    .title{
      display: none;
    }
    .result-title{
      font-size: 24px;
      color: #2B2A3D;
      font-weight: 700;
    }
    button{
      background: #898893;
    }
  }
}
button{
  width: 100%;
  height: 48px;
  border-radius: 4px;
  color: white;
}
@keyframes ani-rotate {
  from{
    transform: rotate(0deg);
  }
  to{
    transform: rotate(360deg);
  }
}
.icon-loading{
  width: 20px;
  height: 20px;
  animation: ani-rotate 2s infinite;
}
</style>
